import { formatTokenValue } from "../../utils/format"
import { NEAR_DECIMALS } from "./config"

export interface ExchangeRate {
  numerator: bigint
  denominator: bigint
}

export function formatNear(amount: bigint): string {
  return formatTokenValue(amount, NEAR_DECIMALS, { fractionDigits: 4 })
}

export function formatBps(bps: number): string {
  return `${new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2,
  }).format(bps / 100)}%`
}

/** LST yocto → NEAR yocto, floor (matches contract `mul_div_floor`). */
export function lstToNear(lst: bigint, rate: ExchangeRate): bigint {
  if (rate.denominator === 0n) return 0n
  return (lst * rate.numerator) / rate.denominator
}

/** NEAR yocto → LST yocto, floor (matches contract `mul_div_floor`). */
export function nearToLst(near: bigint, rate: ExchangeRate): bigint {
  if (rate.numerator === 0n) return 0n
  return (near * rate.denominator) / rate.numerator
}

export function getUnstakeLstAmount({
  inputNear,
  stakedNear,
  stakedLst,
  rate,
}: {
  inputNear: bigint
  stakedNear: bigint
  stakedLst: bigint
  rate: ExchangeRate | null
}): bigint | null {
  if (inputNear === stakedNear) return stakedLst
  // Without a rate a partial NEAR input can't be converted to LST; returning
  // it as-is would burn inputNear LST (> inputNear NEAR). Block submission.
  if (rate == null) return null
  return nearToLst(inputNear, rate)
}
